import React, { useEffect, useRef, useState } from 'react';
import './StatsSection.css';

const StatsSection = () => {
    const sectionRef = useRef(null);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setVisible(true);
                    observer.unobserve(entry.target);
                }
            },
            { threshold: 0.2 }
        );

        if (sectionRef.current) observer.observe(sectionRef.current);

        return () => {
            if (sectionRef.current) observer.unobserve(sectionRef.current);
        };
    }, []);

    return (
        <div className="container my-5" ref={sectionRef}>
            <div className="row g-4 text-center">
                <div className="col-md-6 p-3">
                    <div className={`box-rounded h-100 slide-down ${visible ? 'visible' : ''}`}>
                        <span className="pt-5" style={{'color' : '#835d5d', 'font-size' : '50px', fontWeight : 600}}>Ascolto</span>
                        <h4 className="p-5">Autentico, di una persona in carne ed ossa che risponde senza giudizio e consigli non richiesti. No, niente AI, da nessuna parte. </h4>
                    </div>
                </div>
                <div className="col-md-6 p-3">
                    <div className={`box-rounded h-100 slide-down ${visible ? 'visible' : ''}`}>
                        <span  className="pt-5" style={{'color' : '#835d5d', 'font-size' : '50px', fontWeight : 600}}>Quando ne hai bisogno</span>
                        <h4 className="p-5">Per un momento di noia, una coda, una coincidenza da aspettare, un momento no, una distrazione o un diverso punto di vista su una situazione che ti preoccupa</h4>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default StatsSection;
